import React, {} from 'react'
import PreviewButton from "./PreviewButton"
import GrammarCheckButton from "./GrammarCheckButton"
import DraftButton from "./DraftButton"
import PublishButton from "./PublishButton"
import {useSelector} from "react-redux";
import StatusTextBar from "./StatusTextBar";
import {EDITOR_MODE_HTML} from "../../constants/EditorMode";

function SaveButtons() {
  const editorInitialized = useSelector(state => state.env.editorInitialized);
  const orgPost = useSelector(state => state.post.orgPost);

  if (!editorInitialized) {
    return null;
  }

  return <div className="wrap_btn">
    {!orgPost.id && <DraftButton />}
    <PublishButton />
  </div>
}

function OpenSourceNotice() {
  const mode = useSelector(state => state.env.editorMode);

  if (mode === EDITOR_MODE_HTML) {
    return null
  }

  return <a className='opensource' href='http://t1.daumcdn.net/osa/hermes/notice/1397.html' target='_blank'>
    <span className='mce-ico ico-opensource'>open source</span>
  </a>
}

export default function FooterButtonGroups() {
  const mode = useSelector(state => state.env.editorMode);

  return (
    <>
      <div className="wrap_btn_edit">
        <PreviewButton />
        <GrammarCheckButton />
        <OpenSourceNotice />
      </div>

      <StatusTextBar />

      <SaveButtons />
    </>
  )
}
